module.exports = __webpack_public_path__ + "static/cabina-de-conductor---cupula-55a94a8bd494fed208fd8a1610adb0e2.jpg";